<template>
  <div class="position-relative">
    <div
      v-if="isLoading"
      class="loader d-flex flex-column justify-center align-center position-absolute">
      <v-progress-circular indeterminate color="primary" class="mb-4" />
      <strong>Updating task...</strong>
    </div>

    <v-checkbox
      :disabled="isLoading || isDisabled"
      v-for="(item, idx) in localChecklist"
      :key="idx"
      :model-value="item.complete"
      :label="item.description"
      @update:model-value="onCheck(idx)"
      density="compact"
      hide-details
      class="mb-2" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { type YardTaskChecklist } from '@nova/core';

const props = defineProps<{
  checklistItems: YardTaskChecklist[];
  taskId: string;
  isLoading?: boolean;
  isDisabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update-checklist', payload: { taskId: string; checklist: YardTaskChecklist[] }): void;
}>();

const localChecklist = ref<YardTaskChecklist[]>([...props.checklistItems]);

watch(
  () => props.checklistItems,
  newVal => {
    localChecklist.value = [...newVal];
  }
);

function onCheck(idx: number) {
  if (idx >= 0 && idx < localChecklist.value.length) {
    const item = localChecklist.value[idx];
    localChecklist.value[idx] = { ...item, complete: !item.complete };
    emit('update-checklist', { taskId: props.taskId, checklist: localChecklist.value });
  }
}
</script>

<style lang="scss" scoped>
.loader {
  background: $color-neutral-0;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  opacity: 0.8;
}
</style>
